'use client';

import React from 'react';
import {
  Link as WrapperLink,
  LinkProps,
  ListItem,
  ListItemButton,
  ListItemText,
  SxProps,
} from '@mui/material';
import { Link as NavigableLink } from '../../components/Link';

export type MobileNavMenuItemProps = Omit<LinkProps, 'component' | 'alignItems' | 'ref'>;

const sx: SxProps = {
  width: '100%',
  px: 2,
  py: 1,
};

export const MobileNavMenuItem = React.forwardRef<HTMLAnchorElement, MobileNavMenuItemProps>(
  ({ children, ...props }, ref) => {
    if (!props.href) {
      return (
        <ListItem>
          <ListItemButton component={WrapperLink} ref={ref} sx={sx} {...props}>
            <ListItemText>{children}</ListItemText>
          </ListItemButton>
        </ListItem>
      );
    }

    return (
      <ListItem>
        <ListItemButton
          component={NavigableLink}
          ref={ref}
          href={props.href}
          target={props.type === 'EXTERNAL' ? '_blank' : '_self'}
          prefetch={false}
          sx={sx}
          {...props}
        >
          <ListItemText>{children}</ListItemText>
        </ListItemButton>
      </ListItem>
    );
  }
);
